import { MenuItemType } from "@arelia-components/ui-atoms/menu-selector/models";
import SortIcon from '@mui/icons-material/Sort';
import { CampaignSorting, SortOrderMapType, SortValueGetterMapType } from "./models";
import SortMenuLabel from "@arelia-components/ui-atoms/SortMenuLabel";
import { SortOrder } from "@arelia-types/data-models";

export const sortByMenu: MenuItemType<CampaignSorting>[] = [{
  label: <SortMenuLabel><SortIcon sx={{ transform: "scaleY(-1)" }} />Latest first</SortMenuLabel>,
  value: CampaignSorting.createdDateDesc
}, {
  label: <SortMenuLabel><SortIcon />Oldest first</SortMenuLabel>,
  value: CampaignSorting.createdDateAsc
}, {
  label: <SortMenuLabel><SortIcon sx={{ transform: "scaleY(-1)" }} />Name A-Z</SortMenuLabel>,
  value: CampaignSorting.nameAsc
}, {
  label: <SortMenuLabel><SortIcon />Name Z-A</SortMenuLabel>,
  value: CampaignSorting.nameDesc
}];

export const SortOrderMap: SortOrderMapType = {
  [CampaignSorting.createdDateAsc]: SortOrder.asc,
  [CampaignSorting.createdDateDesc]: SortOrder.desc,
  [CampaignSorting.nameAsc]: SortOrder.asc,
  [CampaignSorting.nameDesc]: SortOrder.desc
};

export const SortValueGetterMap: SortValueGetterMapType = {
  [CampaignSorting.createdDateAsc]: campaign => new Date(campaign.createdAt),
  [CampaignSorting.createdDateDesc]: campaign => new Date(campaign.createdAt),
  [CampaignSorting.nameAsc]: campaign => campaign.name?.trim().toLowerCase() || "\ufff0",
  [CampaignSorting.nameDesc]: campaign => campaign.name?.trim().toLowerCase() || "\ufff0"
};

export const API_ROUTE = "/api/my-fans/campaigns";

export const INITIAL_CAMPAIGN = {
  name: 'New Campaign',
  text: '',
  fans: [],
  createdAt: new Date().toISOString(),
  isRegistrationCompleted: true,
  messageLimit: 0,
  messageLimitCurrent: 0,
};

export const CAMPAIN_TEMPLATES: { [key: string]: string } = {
  "1": "Hello [fan name]. We will be coming to your city to perform at the [venue name] on [date]. Get your tickets here [site url]. If you would like to opt out of future notifications like this, text STOP in reply to this message.",
  "2": "Hello [fan name]. Today is the day. Our latest song, [song name] is now streaming on all major platforms. Listen here: [website url]. If you would like to opt out of future notifications like this, text STOP in reply to this message.",
  "3": "New merch out now! Find your favorite official [band name] merch at the [store name] merch store here - [website url]. If you would like to opt out of future notifications like this, text STOP in reply to this message.",
  "4": "[band name] will be interviewed on [show name] this [date]. Make sure to tune in at [website url]. If you would like to opt out of future notifications like this, text STOP in reply to this message."
}